import { AppRouter } from '@/app/router';
import { KeyboardShortcutsOverlay } from '@/components/ui/KeyboardShortcutsOverlay';

export default function App() {
  return (
    <>
      <AppRouter />
      <KeyboardShortcutsOverlay />
    </>
  );
}
